//
//
//
//
//
//
//
//
//
//
//

import ProcessList from "@/components/ProcessList";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "ProcessSelector",
  components: {ProcessList},
  data: function() {
    return {
      selectedRootProcess: undefined,
      selectedSubProcess: undefined,
      selectedWorkStep: undefined,
      selectedProcess: undefined
    }
  },
  methods: {
    ...mapActions(['updateSelectedProcess']),
    updateRootProcess(process, level) {
      switch (level) {
         case 'ROOT':
           this.selectedRootProcess = process
           this.selectedSubProcess = undefined
           this.selectedWorkStep = undefined
           break
        case 'SUBPROZESS':
          this.selectedWorkStep = undefined
          this.selectedSubProcess = process
           break
        case 'WORKSTEP':
          this.selectedWorkStep = process
      }
      this.selectedProcess = process
      this.updateSelectedProcess(this.selectedProcess)
      this.$router.push({name: 'processes', params: { id: this.selectedProcess.slug}})
    },
    setupProcessSelection(process) {
      let processes = []
      while(process !== undefined) {
        processes.unshift(process)
        process = this.processById(process.parent)
      }
      if(processes.length) {
        this.selectedRootProcess = processes.shift()
        this.selectedProcess = this.selectedRootProcess
      }
      if(processes.length) {
        this.selectedSubProcess = processes.shift()
        this.selectedProcess = this.selectedSubProcess
      }
      if(processes.length) {
        this.selectedWorkStep = processes.shift()
        this.selectedProcess = this.selectedWorkStep
      }
      this.updateSelectedProcess(this.selectedProcess)
    }
  },
  computed: {
    ...mapState(['processData', 'rootProcesses']),
    ...mapGetters(['getChildProcesses', 'processById', 'processBySlug']),
    subProcesses() {
      return this.getChildProcesses(this.selectedRootProcess)
    },
    workSteps() {
      return this.getChildProcesses(this.selectedSubProcess)
    }
  },
  watch: {
    processData() {
      this.setupProcessSelection(this.processBySlug(this.$route.params.id))
    }
  }
}
